<app-global-loader
  [show]="(showLoader$ | async) ?? false"
></app-global-loader>

<router-outlet></router-outlet>
